(function() {
    'use strict';

a3_cabin_reports.directive('issues',issues);

    
    
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name issues
   * @restrict EA
   * @description
   *   Implementation of issues
   *
   *   Initialize the issues telplates for the cabin report form according to their type
   * @attr {String} type The name of the type to initialize the according Issue template.
   * @example
   *   Usage:
   *   <div issues type="travelvalues"></div>
   * @ngInject
   */    
function issues() {

		function templateUrl(type){
			var template='views/reportItems/empty.html';
			if (type=='bar'){
				template='views/Report/bar.tpl.html';
			}
			else if(type=='medicalincidents'){
				template='views/Report/medicalIncidents.tpl.html';
			}

			// else if(type=='securitycheck'){
			// 	template='views/Report/securityCheck.tpl.html';
			// }
			
			else if(type=='specialmeals'){
				template='views/Report/specialMeals.tpl.html';
			}
			else if(type=='supplies'){
				template='views/Report/supplies.tpl.html';
			}
			else if(type=='travelvalues'){
				template='views/Report/travelValues.tpl.html';
			}
			else if(type=='um'){
				template='views/Report/um.tpl.html';
			}
			else if(type=='various'){
				template='views/Report/various.tpl.html';
			}
			else if(type=='wateruplift'){
				template='views/Report/waterUplift.tpl.html';
			}
			else if(type=='groundservices'){
				template='views/Report/groundServices.tpl.html';
			}
			else if(type=='flightOrders'){
				template='views/Report/flightOrders.tpl.html';
			}
			else if(type=='changedseats'){
				template='views/Report/changedSeats.tpl.html';
			}
			else if(type=='upgd'){
				template='views/Report/upgd.tpl.html';
			}
			else if(type=='incompleteServices'){
				template='views/Report/incompleteServices.tpl.html';
			}

			// else if(type=='boardingtimes'){
			// 	template='views/Report/boardingTimes.tpl.html';
			// }
			// else if(type=='disembarkationtimes'){
			// 	template='views/Report/disembarkationTimes.tpl.html';
			// }

			else if(type=='luggage'){
				template='views/Report/luggage.tpl.html';
			}
			else if(type=='foundProperty'){
				template='views/Report/foundProperty.tpl.html';
			}

			return template;
		}
	
		return {
			restrict: 'EA',
			terminal: false,
			templateUrl: function (element, attrs ) { 
					return templateUrl(attrs.type) ;
			},
			scope: false
		}
	}

})();
	